"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReferralCodeResponseDto = instanceOfReferralCodeResponseDto;
exports.ReferralCodeResponseDtoFromJSON = ReferralCodeResponseDtoFromJSON;
exports.ReferralCodeResponseDtoFromJSONTyped = ReferralCodeResponseDtoFromJSONTyped;
exports.ReferralCodeResponseDtoToJSON = ReferralCodeResponseDtoToJSON;
exports.ReferralCodeResponseDtoToJSONTyped = ReferralCodeResponseDtoToJSONTyped;
/**
 * Check if a given object implements the ReferralCodeResponseDto interface.
 */
function instanceOfReferralCodeResponseDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('shareable_url' in value) || value['shareable_url'] === undefined)
        return false;
    if (!('deeplink' in value) || value['deeplink'] === undefined)
        return false;
    return true;
}
function ReferralCodeResponseDtoFromJSON(json) {
    return ReferralCodeResponseDtoFromJSONTyped(json, false);
}
function ReferralCodeResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'shareable_url': json['shareable_url'],
        'deeplink': json['deeplink'],
    };
}
function ReferralCodeResponseDtoToJSON(json) {
    return ReferralCodeResponseDtoToJSONTyped(json, false);
}
function ReferralCodeResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'shareable_url': value['shareable_url'],
        'deeplink': value['deeplink'],
    };
}
